import { ACTION_COLOR_DEFAULT } from "./../ricos-styles/theme-constants.js";
const ACTION_COLOR_LIVESITE = `var(--ricos-native-text-color,  var(--ricos-action-color, ${ACTION_COLOR_DEFAULT.toLowerCase()}))`;
const BG_COLOR_LIVESITE = "var(--ricos-internal-slider-bg-color)";
const SLIDER_THUMB_VISIBILITY = { hover: "hover", fixed: "fixed" };
const SLIDER_TRACK_SIZE = { small: "small_track", medium: "medium_track" };
const PANEL_HEADER_ID = "panel-header";
export {
  ACTION_COLOR_LIVESITE,
  BG_COLOR_LIVESITE,
  PANEL_HEADER_ID,
  SLIDER_THUMB_VISIBILITY,
  SLIDER_TRACK_SIZE
};
//# sourceMappingURL=consts.js.map
